var _rect, _line, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#f3f0ff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 9,
    x2: 24,
    y2: 41,
    stroke: "#8166f4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13 C18 9.5 10 11 8 15.5 C12 13.5 18.5 14.5 24 17.5",
    stroke: "#8166f4",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13 C30 9.5 38 11 40 15.5 C36 13.5 29.5 14.5 24 17.5",
    stroke: "#8166f4",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5 C20 19.5 18.5 23 20.5 26 C22.5 29 26 29 26.5 32.5 C27 36 23 38.5 21 39.5",
    stroke: "#8166f4",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5 C28 19.5 29.5 23 27.5 26 C25.5 29 22 29 21.5 32.5 C21 36 25 38.5 27 39.5",
    stroke: "#8166f4",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 9,
    r: 2,
    fill: "#8166f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ac1e5e96a9b28389b1d27f64584c3f1.svg";
export { ForwardRef as ReactComponent };